import { useSapphireMedia } from '@hex/calculators-shared/hooks';
import { Spinner, Flex } from '@sapphire-react/core';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export const DesktopLoader: React.FC = () => {
  const { isExtraSmall, isSmall } = useSapphireMedia();
  const { t } = useTranslation();

  return (
    <Flex justifyContent={'center'}>
      <Center>
        <Spinner size={isExtraSmall || isSmall ? 'lg' : 'xl'} aria-label={t('loading')} />
      </Center>
    </Flex>
  );
};

const Center = styled.div`
  display: inline-block;
  position: absolute;
  top: 72px;
`;
